/**
 * Credencial da tela de verificação pendente.
 *
 * A assinatura quem confere é o BFF, com o segredo — mas o `exp` precisa ser
 * visto aqui: o token vale 600 s e a pessoa sai da tela para abrir o e-mail,
 * então vencer é o caso rotineiro. Sem esta checagem a tela seguiria
 * mostrando os botões e o BFF responderia 401, que a pessoa leria como erro
 * de código em vez de sessão encerrada.
 */

export type TokenClaims = {
  email?: string
  emailVerified?: boolean
  phoneVerified?: boolean
  phoneMasked?: string
  exp?: number
}

/** Motivos que o BFF devolve quando a credencial, não a ação, é o problema. */
export const SESSION_LOST_ERROR = 'session_expired'

/** `null` quando o token está ausente, malformado, sem `exp` ou vencido. */
export function readClaims(token: string, nowMs: number = Date.now()): TokenClaims | null {
  if (!token) return null
  const part = token.split('.')[1]
  if (!part) return null
  try {
    const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'))
    const claims = JSON.parse(json) as TokenClaims
    if (!claims || typeof claims !== 'object') return null
    if (typeof claims.exp !== 'number' || claims.exp * 1000 <= nowMs) return null
    return claims
  } catch {
    return null
  }
}
